import Action from '.';

export function setDynamic(data,visible) {
    return {
        type: Action.DATA_DYNAMIC,
        dynamic: data,
        visible_dynamic:visible
    }
}

